module.exports = __webpack_public_path__ + "static/media/step1.fcb21bc5.png";